<script lang="ts">
    import { Row, Container } from "sveltestrap";
    import ActivityTimeline from "./ActivityTimeline.svelte";
    import InvoiceOverview from "./InvoiceOverview.svelte";
    import Selling from "./Selling/Selling.svelte";
    import TopDealer from "./TopDealer.svelte";
    import YearlyGrowth from "./YearlyGrowth.svelte";
    import { onMount } from "svelte";
    import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
    let ispreloader:boolean = false;
    onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
</script>
{#if !ispreloader }
    <PreLodaer />
{/if}
<Container fluid>
    <Row>
        <InvoiceOverview />
        <TopDealer />
        <Selling />
        <ActivityTimeline />
        <YearlyGrowth />
    </Row>
</Container>
